import { motion } from 'framer-motion'
import { Coffee, Lightbulb, Rocket, TrendingUp } from 'lucide-react'

const steps = [
  {
    number: '01',
    icon: Coffee,
    title: 'Konzultáció',
    subtitle: 'Kávézunk egyet',
    description: 'Megismerem a vállalkozásod, céljaidat és kihívásaidat. Ingyenes, kötelezettségmentes beszélgetés.',
  },
  {
    number: '02',
    icon: Lightbulb,
    title: 'Stratégia',
    subtitle: 'Pörkölés',
    description: 'Személyre szabott marketing tervet készítek, ami illeszkedik a költségvetésedhez és céljaidhoz.',
  },
  {
    number: '03',
    icon: Rocket,
    title: 'Megvalósítás',
    subtitle: 'Főzés',
    description: 'Elkezdjük az együttműködést. Weboldal, hirdetések vagy SEO – minden egy kézből.',
  },
  {
    number: '04',
    icon: TrendingUp,
    title: 'Növekedés',
    subtitle: 'Élvezd!',
    description: 'Folyamatosan mérjük és optimalizáljuk az eredményeket. A Te sikered az én sikerem.',
  },
]

const Process = () => {
  return (
    <section id="folyamat" className="py-24 md:py-32 bg-coffee-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <motion.span
            className="text-coffee-600 text-sm font-medium tracking-widest uppercase block mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Hogyan dolgozunk?
          </motion.span>
          <motion.h2
            className="font-heading text-4xl md:text-5xl font-bold text-coffee-900 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Egyszerű folyamat,{' '}
            <span className="relative inline-block">
              látványos eredmények
              <motion.span
                className="absolute bottom-1 left-0 right-0 h-2 bg-coffee-200/60 -z-10"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.5 }}
              />
            </span>
          </motion.h2>
          <motion.p
            className="text-lg text-coffee-600 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Mint egy jó kávé elkészítése – minden lépés számít az eredményért.
          </motion.p>
        </div>

        {/* Process steps */}
        <div className="relative">
          {/* Connection line - desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-coffee-200" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {steps.map((step, index) => {
              const Icon = step.icon
              return (
                <motion.div
                  key={step.number}
                  className="relative"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.15 }}
                >
                  {/* Step number circle */}
                  <div className="relative z-10 w-12 h-12 bg-coffee-900 text-cream rounded-full flex items-center justify-center font-bold text-sm mb-6 mx-auto lg:mx-0">
                    {step.number}
                  </div>

                  {/* Card */}
                  <div className="bg-white rounded-2xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] text-center lg:text-left">
                    <div className="w-14 h-14 bg-coffee-100 rounded-xl flex items-center justify-center mb-4 mx-auto lg:mx-0">
                      <Icon size={28} className="text-coffee-600" />
                    </div>
                    <h3 className="font-heading text-xl font-bold text-coffee-900 mb-1">
                      {step.title}
                    </h3>
                    <p className="font-accent text-coffee-500 text-lg mb-3">
                      {step.subtitle}
                    </p>
                    <p className="text-coffee-600 text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </motion.div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Process
